import { render, staticRenderFns } from "./MovieSimple.vue?vue&type=template&id=d2abcb30"
import script from "./MovieSimple.vue?vue&type=script&lang=js"
export * from "./MovieSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports